// Generated by genversion.
export const version = '4.0.17';
//# sourceMappingURL=version.js.map